<template>
  <div class="tw-flex tw-flex-col tw-items-center tw-mt-24 wrap">
    <div class="tw-p-4">
      <img src="~@/assets/img/logo/nrl-green.svg" alt="nrl" class="logo" />
    </div>
    <button
      class="tw-py-2 tw-text-sm tw-font-medium tw-tracking-widest tw-text-white tw-uppercase tw-bg-green-700 tw-rounded hover:tw-bg-green-300 tw-px-7 hover:tw-text-black"
      id="login"
      type="success"
      @click="redirect()"
    >
      Login with NRL Account
    </button>
  </div>
</template>

<script>
import { getAuth0 } from '@/auth/auth0';

export default {
  name: 'index',
  props: {},
  created() {
    if (this.$store.getters['user/isAuthenticated']) {
      const redirect = this.$store.getters['user/redirectUriPath'];
      this.$router.push(`${redirect}`);
    }
  },
  data() {
    return {};
  },
  methods: {
    async redirect() {
      try {
        const auth0 = getAuth0();
        await auth0.loginWithRedirect({
          authorizationParams: {
            redirect_uri: process.env.VUE_APP_AUTH_REDIRECT_URI
          },
          appState: {
            target: this.$route.query.redirect || "/landing"
          }
        });
      } catch (err) {
        console.error("Auth0 login error:", err);
        this.$customError("Failed to login. Please try again.");
      }
    }
  },
};
</script>

<style scoped lang="scss">
.wrap {
  height: 117px;
  max-height: 117px;
  text-align: center;
  .logo {
    max-height: 100%;
    width: 120px;
  }
}

.login-container {
  min-height: 100%;
  width: 100%;
  overflow: hidden;
  .login-form {
    text-align: center;
    position: relative;
    width: 400px;
    max-width: 100%;
    padding: 160px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }
  .btn-container {
    margin-top: 50px;
  }
  .el-input {
    display: inline-block;
    width: 100%;
  }
  .el-button {
    width: 90%;
    margin-top: 2rem;
  }
  @media only screen and (max-width: $sm) {
    .login-form {
      width: auto;
    }
  }
}
</style>
